import { buildQueryParams } from "../utils/buildQueryParams";
import { APIInstance } from "./api.config";

const { api } = new APIInstance({ path: "/v1/purchase/" });

export const PurchaseService = {
  createVendor: (vendorDetails) => {
    return api.post("/vendors", vendorDetails);
  },

  getVendors: (filters = {}) => {
    const params = buildQueryParams(filters);
    return api.get(`/vendors?${params.toString()}`);
  },

  getVendorById: (vendorId, filters = {}) => {
    const params = buildQueryParams(filters);
    return api.get(`/vendors/${vendorId}?${params.toString()}`);
  },

  updateVendor: (vendorId, vendorDetails) => {
    return api.put(`/vendors/${vendorId}`, vendorDetails);
  },

  deleteVendor: (vendorId) => {
    return api.delete(`/vendors/${vendorId}`);
  },

  createContract: (contractDetails) => {
    return api.post("/contracts", contractDetails);
  },

  getContracts: (filters = {}) => {
    const params = buildQueryParams(filters);
    return api.get(`/contracts?${params.toString()}`);
  },

  getContractById: (id) => {
    return api.get(`/contracts/${id}`);
  },

  updateContract: (contractId, contractDetails) => {
    return api.put(`/contracts/${contractId}`, contractDetails);
  },

  deleteContract: (contractId) => {
    return api.delete(`/contracts/${contractId}`);
  },

  getPurchaseItems: (filters = {}) => {
    const params = buildQueryParams(filters);
    return api.get(`/items?${params.toString()}`);
  },

  createPurchaseItem: (itemDetails) => {
    return api.post("/items", itemDetails);
  },

  getPurchaseItemById: (itemId) => {
    return api.get(`/items/${itemId}`);
  },

  updatePurchaseItem: (itemId, itemDetails) => {
    return api.put(`/items/${itemId}`, itemDetails);
  },

  deletePurchaseItem: (itemId) => {
    return api.delete(`/items/${itemId}`);
  },

  getUnitOfMeasurements: (filters = {}) => {
    const params = buildQueryParams(filters);
    return api.get(`/items/unit-of-measurements?${params.toString()}`);
  },

  getPurchases: (filters) => {
    const params = buildQueryParams(filters);
    return api.get(`/invoices?${params.toString()}`);
  },

  getPurchaseById: (purchaseId) => {
    return api.get(`/invoices/${purchaseId}`);
  },

  createPurchase: (purchaseDetails) => {
    return api.post("/invoices", purchaseDetails);
  },

  updatePurchase: (purchaseId, purchaseDetails) => {
    return api.put(`/invoices/${purchaseId}`, purchaseDetails);
  },

  deletePurchase: (purchaseId) => {
    return api.delete(`/invoices/${purchaseId}`);
  },

  // Purchase Return
  createPurchaseReturn: (purchaseReturnDetails) => {
    return api.post("/returns", purchaseReturnDetails);
  },

  getPurchaseReturnById: (purchaseReturnId) => {
    return api.get(`/returns/${purchaseReturnId}`);
  },

  updatePurchaseReturn: (purchaseReturnId, purchaseReturnDetails) => {
    return api.patch(`/returns/${purchaseReturnId}`, purchaseReturnDetails);
  },

  deletePurchaseReturn: (purchaseReturnId) => {
    return api.delete(`/returns/${purchaseReturnId}`);
  },
};
